<template>
  <div class="c-team-popin u-pos-tl u-viewport-fit-h u-fit-w u-vacuum u-absolute"  :class="{'u-fixed':$root.isTouch,'u-absolute':!$root.isTouch}"   style="transform: translateY(0px) translateZ(0px);z-index:10000;">
   <div class="c-team-popin__content u-absolute u-pos-tl u-fit-w">
      <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-tl u-fit-w u-bg--brand-dark"></div>
      <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark"></div>
      <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-bl u-fit-w u-bg--brand-dark"></div>
      <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark"></div>
   </div>
   <div class="c-team-popin__content o-wrapper--panel u-fit u-bg--white">
      <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-tl u-fit-w u-bg--brand-dark"></div>
      <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-tr u-fit-h u-bg--brand-dark"></div>
      <div class="c-team-popin__bar c-team-popin__bar--x u-absolute u-pos-br u-fit-w u-bg--brand-dark"></div>
      <div class="c-team-popin__bar c-team-popin__bar--y u-absolute u-pos-bl u-fit-h u-bg--brand-dark"></div>
      <div class="o-wrapper--panel u-fit u-pad-t-ultra u-pad-b-xxl u-pad-x-w2of12 u-overflow-s">
         <div class="u-relative">
            <h2 class="t-h3 t-text--roman u-color--brand-dark u-marg-b-xl">{{content.title}}</h2>
            <core-emit  inline-template tag="button" class="u-hide@sm t-btn t-btn--hovered t-text--sm t-text--base-bold u-relative u-inline-block u-color--brand-blue-dark js-button-hovered" state="print:page" href="javascript:void(0);">
              <div @click="onDispatch">
                <div class="t-btn--hovered__primary u-flex u-flex-ai--center u-flex-jc--center">
                  <img src="/assets/medias/images/icons/print.svg" class="t-icon--print"></div>
                  <div class="t-btn--hovered__secondary u-absolute u-overflow-h">
                   <div class="t-btn--hovered__secondary-content u-flex u-flex-ai--center u-flex-jc--center">
                      Print
                   </div>
                </div>
              </div>
            </core-emit>
         </div>
         <div class="u-flex u-flex-fw--wrap">
            <div class="c-team-bord-popin__item u-inline-block u-marg-b-xl"      v-for="(item, index)  in content.subsidiaries">
               <div class="c-line c-line--x u-bg--black u-fit-w u-marg-b-lg"></div>
               <h5 class="t-h6 t-text-lh--xl t-text--base-bold u-color--gray-light u-marg-b-sm">{{item.first_name}}&nbsp;{{item.last_name}}</h5>
               <span class="t-text--sm u-color--gray-dark">{{item.position}}</span> <br>
               <div class="c-team-bord-popin__item__description u-inline-block t-text--sm t-text--base-bold u-color--gray" v-html="item.description">
                </div>
           </div>
           </div>
         <div class="c-team-popin__aside o-wrapper--valign u-fixed u-align-right u-bg--brand-dark u-hide@sm">
            <div class="c-team-popin__aside__content u-inline-block u-valign-middle u-marg-r-lg">
               <div class="u-inline-block u-valign-middle">
                 <span class="t-text--xs u-inline-block u-valign-middle u-color--alpha-white u-marg-r-sm">{{content.title}}</span>
                  <span class="c-line c-line--x u-inline-block u-valign-middle u-bg--white u-marg-r-sm" style="width: 45px;"></span>
                  <span class="t-text--xs u-inline-block u-valign-middle u-color--alpha-white">{{"00"+(index+1)}}</span></div>
            </div>
         </div>
      </div>
   </div>
</div>
</template>
<script>
import      AppScrollObject  from  '../app-scroll-object/index.vue'
import      CoreEmit from     '../core-emit/index.vue'
export default
{
  name: "app-team-board-popin",
                 props: {
                   debug: {
                     type: Boolean,
                     default: !1
                 },
                     content: {
                         type: Object,
                         default: function () { }
                     },
                     isActive: {
                         type: Boolean,
                         default: !1
                     },
                     title: {
                         type: String,
                         default: ""
                     },
                     index: {
                         type: Number,
                         default: 0
                     }
                 },
                 components: {
                   "app-scroll-object":AppScrollObject,
                    "core-emit":CoreEmit
                 },
                 watch: {
                     isActive: "onActiveChange"
                 },
                 methods:
                     {
                         onActiveChange: function () {
                             this.isActive ? (document.addEventListener("keydown", this._onKeydown),
                             this.$root.isTouch || (this.$el.style.transform = "translateY(" + this.$root.smoothScroll + "px) translateZ(0)"),
                                 this.$el.classList.add("is-visible")) : (document.removeEventListener("keydown", this._onKeydown),
                                 this.$el.classList.remove("is-visible"))
                         },
                         onPrintPage: function () {
                             window.print()
                         },
                         _onKeydown: function (t) {
                             27 === t.keyCode && this.eventHub.$emit("close:popin")
                         }
                     }
             }

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/app-team-board-popin/index.vue